// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"f10bd363","693":"7c53eb1e","710":"8dbfd61e","983":"902e5219"}[chunkId] + ".chunk.js";
};